<template>
  <div>
    <header>{{msg}}</header>
      <div class="boxhos">
        <a class="colligateHos" href="/#/order">
          <div>
            <img src="../assets/colli.png" alt="" title="" width="100%;"/>
          </div>
        </a>
        <a class="sanyeHos" href="javascript:;" data-url="/#/orderSanye" @click="eve()">
          <div>
            <img src="../assets/sanye.png" alt="" title="" width="100%;"/>
          </div>
        </a>
      </div>
    <DownloadApp></DownloadApp>
    <MenuFooters :isHide="isHide" :menuType="currentMenuType"></MenuFooters>
  </div>
</template>
<script>
  import Vue from 'vue';
  import axios from 'axios';
  import { setSid, getSid } from '../utils/SidManager';
  import getConfig from '../utils/config';
  import {getUrl} from '../utils/WebRequest';
  var config = getConfig();
  import DownloadApp from './DownloadApp';
  import MenuFooters from './Footer';



  export default {
    name: 'ChooseHos',
    components: {
      DownloadApp,
      MenuFooters
    },
    data () {
      return {
        msg: '茄子生活',
        currentMenuType: 'order',
        user:{ sid: getSid() },
        isHide:false
      }
    },
    methods: {
      errorTip: function($target, tip) {
        $target.show();
        $target.text(tip);

        setTimeout(function() {
          $target.removeClass('error-tip');
          $target.addClass('error-tip-fade');

          setTimeout(function() {
            $target.removeClass('error-tip-fade');
            $target.addClass('error-tip');

            $target.hide();
          }, 500);
        }, 2000);
      },
      getMyInfo: function(){
        document.body.scrollTop =0;
        var formData = JSON.stringify(this.user);
        axios.post(getUrl(config.url_map.getUserInfo), JSON.parse(formData))
          .then(function(res) {
            if(res.data.status.error_code === 0){
               $('.sanyeHos').attr('href',$('.sanyeHos').attr('data-url'));
            }else if (res.data.status.error_code === 2){

            }else{
              this.errorTip($('#J_ErrorTip'),res.data.status.error_msg);
            }
          }.bind(this))
          .catch(function(err) {
            console.log(err);
          });
      },
      getHeight:function(){
          var totleHeight = $(window).height();
          var headerHeight = parseInt($("header").css("height"));
          var footerHeight = parseInt($("footer").css("height"));
          var boxHeight = totleHeight - headerHeight - footerHeight;
          $(".boxhos").css("height",boxHeight);

        $(window).resize(function(){
          var totleHeight = $(window).height();
          var headerHeight = parseInt($("header").css("height"));
          var footerHeight = parseInt($("footer").css("height"));
          var boxHeight = totleHeight - headerHeight - footerHeight;
          $(".boxhos").css("height",boxHeight);
        });
      },
      eve: function(){
        this.$router.push({name:'Login',params:{type:'orderSanye'}});
      }
    },

    created: function(){
      this.getMyInfo();
    },
    mounted: function(){
      this.getHeight();
    }
  }
</script>



// WEBPACK FOOTER //
// ChooseHos.vue?20485ca7